tablinks<template>

  <div >
    <md-dialog :md-active.sync="showDialog" :md-click-outside-to-close="false">
      <md-dialog-title v-if="isCreate" id="dr_title">Create FSI Driver</md-dialog-title>
      <md-dialog-title v-if="isUpdate" id="dr_title">Update FSI Driver</md-dialog-title>
        <div id="actionButton" style="margin-top: -50px; margin-left: 250px;">
            <md-button class="md-raised custButton" @click="cancelAction"><span clas="icons-center material-icons"></span>Cancel</md-button>
            <md-button id="create" class="md-raised custButton" @click="saveData"><span class="icons-center material-icons"></span>Save</md-button>
            <md-switch v-model="dataForm.active" :disabled="isCreate">Active</md-switch>
         </div> 
         <div class="tab">
            <md-button class="tablinks" @click="openTab('Main')" v-if="isCreate || isUpdate">Main</md-button>
         </div>
    <!--       
       <nav>
    <ul>
      <li class="item"><a href="#">link 1</a></li>
      <li class="item"><a href="#">link 2</a></li>
      <li class="item"><a href="#">link 3</a></li>
      <li class="item"><a href="#">link 4</a></li>
      <li class="item"><a href="#">link 5</a></li>
    </ul>
  </nav>
  -->     
      <md-dialog-content >
        <div style="width: 600px; height: 550px">
         <form id="top" @submit.prevent="doSaveUser">
         <md-button type="submit" id="submit" style="display:none;" ></md-button> 
         <span class="info" id="status" style="display:none"></span>
         
         <div id="Main" class="tabcontent" v-if="isCreate || isUpdate">
            <div v-if="isUpdate" class = "layout">
                <!--
                <md-field>
                <label for="driverId">DRIVER ID</label>
                <md-input name="driverId" disabled
                        id="driverId"
                        autocomplete="new-password"
                        v-model="dataForm.driverId"
                />
                </md-field>
                -->
                <md-field>
                <label for="fullName">DRIVER FULL NAME</label>
                <md-input name="fullName" disabled
                        id="fullName"
                        autocomplete="new-password"
                        v-model="driverFullName"
                />
                </md-field>
            </div>

            <div class = "layout" v-if="isCreate || isUpdate">
                <template v-if="isCreate">
                  <md-field :class="getValidationClass('dataForm.firstName')">
                    <label for="firstName">FIRST NAME</label>
                    <md-input name="firstName"
                        id="firstName"
                        autocomplete="new-password"
                        v-model="dataForm.firstName"
                    />
                    <span class="md-error" v-if="!$v.dataForm.firstName.required">Driver first name is required</span>
                  </md-field>
                </template>
                <template v-if="isUpdate">
                  <md-field :class="getValidationClass('dataForm.firstName')">
                    <label for="firstName">FIRST NAME</label>
                    <md-input name="firstName"
                        id="firstName"
                        autocomplete="new-password"
                        v-model="dataForm.firstName" disabled
                    />
                    <span class="md-error" v-if="!$v.dataForm.firstName.required">Driver first name is required</span>
                  </md-field>
                </template>
            </div>
            <div class = "layout" v-if="isCreate || isUpdate">
                <template v-if="isCreate">
                   <md-field :class="getValidationClass('dataForm.lastName')">
                     <label for="shortId">LAST NAME</label>
                     <md-input name="lastName"
                          id="lastName"
                          autocomplete="new-password"
                          v-model="dataForm.lastName"
                      />
                   </md-field>
                </template>
                <template v-if="isUpdate">
                   <md-field :class="getValidationClass('dataForm.lastName')">
                     <label for="shortId">LAST NAME</label>
                     <md-input name="lastName"
                          id="lastName"
                          autocomplete="new-password"
                          v-model="dataForm.lastName" disabled
                      />
                   </md-field>
                </template>
            </div>

            <div class = "layout" v-if="isCreate || isUpdate">
                <template v-if="isCreate">
                   <md-field :class="getValidationClass('dataForm.driverMobile')">
                     <label for="driverMobile">DRIVER MOBILE</label>
                     <md-input name="driverMobile"
                        id="driverMobile"
                        autocomplete="new-password"
                        v-model="dataForm.driverMobile"
                     />
                     <span class="md-error" v-if="!$v.dataForm.driverMobile.required">Driver Mobile number is required</span>
                   </md-field>
                </template> 
                <template v-if="isUpdate">
                   <md-field :class="getValidationClass('dataForm.driverMobile')">
                     <label for="driverMobile">DRIVER MOBILE</label>
                     <md-input name="driverMobile"
                        id="driverMobile"
                        autocomplete="new-password"
                        v-model="dataForm.driverMobile" disabled
                     />
                     <span class="md-error" v-if="!$v.dataForm.driverMobile.required">Driver Mobile number is required</span>
                   </md-field>
                </template> 
            </div>

            <div class = "layout" v-if="isCreate || isUpdate">
                <md-field :class="getValidationClass('dataForm.trailerNum')">
                <label for="trailerNum">TRAILER NUMBER</label>
                <md-input name="trailerNum"
                        id="trailerNum"
                        autocomplete="new-password"
                        v-model="dataForm.trailerNum"
                />
                <!--
                <span class="md-error" v-if="!$v.dataForm.trailernum.required">Trailer number is required</span>
                -->
                </md-field>
            </div>

            <div class = "layout" v-if="isCreate || isUpdate">
                <md-field :class="getValidationClass('dataForm.tractorNum')">
                <label for="tractorNum">TRACTOR NUMBER</label>
                <md-input name="tractorNum"
                        id="tractorNum"
                        autocomplete="new-password"
                        v-model="dataForm.tractorNum"
                />
                <!--
                <span class="md-error" v-if="!$v.dataForm.trailernum.required">Trailer number is required</span>
                -->
                </md-field>
            </div>

            <div class="layout2" v-if="isUpdate">
                <md-field :class="getValidationClass('dataForm.lastUseOn')">
                <label for="tractorNum">LAST USE ON</label>
                <md-input name="lastUseOn"
                        id="lastUseOn"
                        autocomplete="new-password"
                        v-model="dataForm.lastUseOn"
                        disabled
                />
                <!--
                <span class="md-error" v-if="!$v.dataForm.trailernum.required">Trailer number is required</span>
                -->
                </md-field>
            </div>
            <!--
            <div class="layout3" v-if="isUpdate">
              <label for="resetlastuseon">Reset Last Use On</label>
              <md-checkbox v-model="dataForm.resetLastUseOn"></md-checkbox>
            </div>
          -->
          </div>
        </form>  
       </div> 
       
      </md-dialog-content>
    </md-dialog>
  </div>
</template>


<style scoped>
/*
form {
    min-width: 640px;
    margin: 24px;
  }
*/  

.alwaysShow {
  position: fixed;
  right: 60px;
  top : 30px;
}

.icons-center {
    vertical-align: middle;
    margin-right: 10px;
}

.custButton {
    margin: 10px;
    width: 120px;
    height: 40px;
    line-height:40px;
    font-size: 0.9rem;
   
}

.heading{
      padding-top: 10px;
     margin-bottom: 0;
      color: #555555;
      width: 92%;
      line-height: 3;
      font-size: 40px;
      font-family: Roboto Slab;
      margin-left: 44px;
}

  .layout{
      padding-top: 7px;
      padding-bottom: 7px;
      width: 92%;
      line-height: 1.5;
      color: #555555;
      font-family: Roboto Slab;
      margin: auto;
  }

  .layout2{
      padding-top: 7px;
      padding-bottom: 7px;
      width: 50%;
      line-height: 1.5;
      color: #555555;
      font-family: Roboto Slab;
      /*margin: auto;*/
      margin-left: 20px;
  }

  .layout3{
      padding-top: 7px;
      padding-bottom: 7px;
      width: 50%;
      line-height: 1.5;
      color: #555555;
      font-family: Roboto Slab;
      /*margin: auto;*/
      margin-left: 300px;
      margin-top: -55px;
  }

  .tab {
      overflow: hidden;
      border: 1px solid #ccc;
      background-color: #f1f1f1;
  }

  .tab button {
      background-color: inherit;
      float: left;
      border: none;
      outline: none;
      cursor: pointer;
      padding: 14px 16px;
      transition: 0.3s;
  }

  .tab button:hover {
      background-color:#ddd;
      text-decoration: underline;
  }

  .tab button:active, button:focus{
      background-color: #ccc;
      text-decoration: underline;
  }

  .tabcontent {
      /*display: none;*/
      padding: 6px 12px;
      border: 1px solid #ccc;
      border-top: none;
      width: 500px;
  }

  .tablinks {
    /*
      font-family: Roboto Slab;
      text-decoration: none;
      font-size: 0.9rem;
    */
      height: 50px;
  }

  .info {
    background-color: #2196f3;
    display: inline-block;
    font-size: 18px;
    font-weight: 600;
    color: white;
    padding: 8px;
    height: 30px;
  }

</style>


<script>
  import { validationMixin } from 'vuelidate';
  import { mapGetters } from 'vuex';
  import { minLength, required , maxLength} from 'vuelidate/lib/validators';
  import callingApiCenter from "../components/CallingApiCenter.vue";
  //import api from '../api';
  import { newAPIPost } from '../api/index.js';

  const getInitialFSIDriverdata = () => ({
    office: null,
    driverId: null,
    firstName: null,
    lastName: null,
    driverMobile: null,
    trailerNum: null,
    tractorNum: null,
    lastUseOn: null,
    resetLastUseOn: false,
    active: true,
    //parking: null,
    //manifestBooklet: null,
    //insurance: null
  });
  const processRequest = () => ({
    firstName: null,
    lastName: null,
    driverMobile: null,
    trailerNum: null,
    tractorNum: null,
    active: null,
    mode: null,
  });

  export default {
    components: { callingApiCenter},
    mixins: [validationMixin],
    props: {
      mode: String,
      //driverOffice: String,
      onfsicreate: Function,
    },
    data: () => ({
      showDialog: false,
      dataForm: getInitialFSIDriverdata(),
      //searchReq: searchRequest(),
      items: [],
      selected:null,
      drivers: [],
      isUpdate: false,
      isCreate: false,
      //isLicExpHist: false,
      //isCreateUpdate: true,
      //isInboundCallCreate: false,
      //isInboundCallUpdate: false,
      filter: "",
      //isMain: true,
      isFSIMain: false,
      //isDriver: false,
      //isArea: false,
      //isBilling: false,
      //isInbound: false,
      users: [],
      userIds: [],
      driverFullName: null,
      p_apptNo: null,
    }),

    computed: {
      ...mapGetters([
        'getMasterDataByGroup',
        'getMasterDataName',
        'getUserProfile',
        'getUsers',
      callingApiCenter,
      ]),
      getGSTDriverTruckLog() {
        console.log("getGSTDriverTrucklog:");
      },  
    filteredRows(){
        return this.items.filter(row => {
          const term = this.filter.toUpperCase();
          return this.includeNull(null).includes(term)
        })
      },

      getSelectedItems() {
        return _(this.items)
          .filter(it => it.selected);
      },

      getEditingItems() {
        return _(this.items)
          .filter(it => it.editing);
      },

      canEdit() {
        return this.getSelectedItems.length === 1 ;
      },

    },

    watch: {
      getGSTDriverMaster(val) {
        this.updateItems(val);
      },
      getGSTDriverTruckLog(val) {
        console.log("watch method");
        this.updateItems(val);
      },
    },


    validations: {
      dataForm: {
          firstName: {required},
          lastName: {},
          driverMobile:{required},
          trailerNum:{},
          tractorNum: {}
      },
    },



    methods: {
      openDialog(processdata) {
        this.$store.commit('clearApiError');
        this.$v.dataForm.$reset();
        console.log(this.$v.dataForm.$invalid);
        this.dataForm = getInitialFSIDriverdata();
        console.log("update form: " + this.mode);
        console.log("request data: " + JSON.stringify(processdata));

        //this.$store.dispatch('loadUsers', {category: 'A1'});
        //this.loadUsers(this.getUsers);

        if (processdata) {
          if (this.mode === "CREATE") {
            this.isCreate = true;
            this.isUpdate = false;
            this.isFSIMain = true;
            this.p_apptNo = processdata.apptNo;
          }
          if (this.mode === "UPDATE") {
            this.isCreate = false;
            this.isUpdate = true;
            this.isFSIMain = true;
            this.dataForm.driverId = processdata.driverId;
            this.dataForm.office = processdata.office;
            this.dataForm.firstName = processdata.firstName;
            this.dataForm.lastName = processdata.lastName;
            this.dataForm.driverMobile = processdata.driverMobile;
            this.dataForm.tractorNum = processdata.tractorNum;
            this.dataForm.trailerNum = processdata.trailerNum;
            this.dataForm.lastUseOn = this.convertdateformat(processdata.lastUseOn);
            this.dataForm.active = processdata.active;
            this.driverFullName = processdata.firstName;
            this.p_apptNo = processdata.apptNo;
            if (processdata.lastName != null && processdata.lastName != "")
            {
               this.driverFullName += " " + processdata.lastName;
            }
          }
          this.showDialog = true;
        } else {
          alert("No info to process!!");
          this.showDialog = false;
        }


      },

      updateItems(itemsSource) {
          console.log("itemsSource: " + itemsSource);
          var items = JSON.parse(JSON.stringify(itemsSource));
          items.forEach((it) => {
            it.backGroud = false;
            it.selected = false;
            it.editing = false;
          });
          console.log("items:" + items);
          this.items = items;
      },

      loadUsers(itemsSource) {
         console.log("userlist: " + JSON.stringify(itemsSource));
         this.users = itemsSource;
         this.users.forEach( (it) => {
            if (!this.userIds.includes(it.username))
               this.userIds.push(it.username);
         })
         console.log("userIds: " + JSON.stringify(this.userIds));

      },

      handleScroll(e) {
            $(this.$el.querySelector('.table-header'))
            .offset({
                left: -1 * (e.target.scrollLeft - $('.outer-container')
                .offset().left),
            });
      },


      getValidationClass(fieldName) {
        const field = _(this.$v)
          .lookup(fieldName);
        if (field) {
          return {
            'md-invalid': field.$invalid && field.$dirty,
          };
        }
        return {};
      },

      // handleSalesOfficeChanged(id){
      //     console.log('saleoffice id:' + id );
      //     this.dataForm.defaultSalesOffice = id;
      // },

      // handleDriverTypeChanged(id){
      //     console.log('Driver Type id:' + id );
      //     this.dataForm.driverType = id;
      // },

      // handleDriverStatusChanged(id){
      //     console.log('Driver Status id:' + id );
      //     this.dataForm.driverStatus = id;
      // },

      // handleDriverStateChanged(id){
      //     console.log('Driver State id:' + id);
      //     this.dataForm.driverState = id;
      // },

      // handleDriverCompanyChanged(id){
      //     console.log('Driver Company id:' + id);
      //     this.dataForm.driverCompany = id;
      // },

      // handleUserNameChanged(id) {
      //     this.dataForm.userName = id;
      // },

      includeNull(field){
                return field==null ? '' : field;
            },



     cancelAction(){
        this.isFSIMain = false;
        this.isCreate = false;
        this.isUpdate = false;
        this.showDialog = false;
        this.$store.commit('clearApiError');
     },

     async doSaveUser() {
        //this.isMain = true;
        //this.isDriver = false;
        //this.isArea = false;
        //this.isBilling = false;
        this.$v.dataForm.$touch();
        const drivermobilereg = /^1[0-9]{10}$/;
        console.log(`check mobile: ${drivermobilereg.test(this.dataForm.driverMobile)}`);
        if (this.$v.dataForm.$invalid) {
          return;
        }
        if (this.dataForm.firstName == null || this.dataForm.firstName == "")
        {
          this.$buefy.notification.open({
                    duration: 5000,
                    message: `Driver First Name is required!.`,
                    position: 'is-top',
                    type: 'is-danger',
                    hasIcon: true
                });
          return;

        } else {
          this.dataForm.firstName = this.dataForm.firstName.trim();
        }
        if (this.dataForm.driverMobile == null || this.dataForm.driverMobile == "")
        {
          this.$buefy.notification.open({
                    duration: 5000,
                    message: `Driver Mobile# is required!.`,
                    position: 'is-top',
                    type: 'is-danger',
                    hasIcon: true
                });
          return;

        } else {
          this.dataForm.driverMobile = this.dataForm.driverMobile.trim();
        }
        if (!drivermobilereg.test(this.dataForm.driverMobile))
        {
          this.$buefy.notification.open({
                    duration: 5000,
                    message: `Phone number is not in 1<area code><number> format!. Please correct and try again.`,
                    position: 'is-top',
                    type: 'is-danger',
                    hasIcon: true
                });
          return;

        }
        else {
          console.log(`find phone pattern: ${this.dataForm.driverMobile}`);
        }
        var req = processRequest();
        req.firstName = this.dataForm.firstName.toUpperCase();
        if (this.dataForm.lastName == null || this.dataForm.lastName == "")
        {
          req.lastName = this.dataForm.lastName;  
        } else {
          req.lastName = this.dataForm.lastName.toUpperCase();
        }
        req.driverMobile = this.dataForm.driverMobile;
        if (this.dataForm.tractorNum == null || this.dataForm.tractorNum == "")
        {
           req.tractorNum = this.dataForm.tractorNum;
        } else {   
           req.tractorNum = this.dataForm.tractorNum.toUpperCase();
        }   
        if (this.dataForm.trailerNum == null || this.dataForm.trailerNum == "")
        {
           req.trailerNum = this.dataForm.trailerNum;
        } else {   
           req.trailerNum = this.dataForm.trailerNum.toUpperCase();
        }
        req.active = this.dataForm.active;
        if (this.mode === "CREATE")
        {
          req.mode = "C";
        }

        var debug = false;
        var statusObj;
        if (!debug)
        {
          //await api.post("/api/w/fsi/updateDriverData", req)
          await newAPIPost("/api/w/fsi/updateDriverData", req)
            .then((it) => {
              this.$store.commit('clearApiError');
              console.log("update result: " + JSON.stringify(it[0]));
              this.showDialog = false;
              if (it.length > 0)
              {
                 console.log("has record from create");
                 this.onfsicreate(it[0].driverId, it[0].fullName, it[0].driverMobile, it[0].tractorNum, it[0].trailerNum, this.p_apptNo);
              } else {
                 console.log("has no record from create");
                 this.onfsicreate(null,null,null,null,null,null);
              }
              $('.btn-search-master-form-driver')
               .click();

            


            // if (it.shortId != "EXISTED")
            // {
            //    this.showDialog = false;
            //    console.log("apptNo: " + this.dataForm.apptNo);
            //    this.onCreate(this.dataForm.shortId, this.dataForm.driverMobile, this.dataForm.defaultPlateNum, this.dataForm.trailernum, this.dataForm.apptNo);
            //    //this.onCreate(this.dataForm.shortId, this.dataForm.driverMobile, this.dataForm.defaultPlateNum, this.dataForm.apptNo);
            //    $('.btn-search-master-form-driver')
            //      .click();
            // }
            // else
            // {
            //    statusObj = document.getElementById("status");
            //    console.log("statusObj: " + statusObj);
            //    if (statusObj)
            //    {
            //       statusObj.innerText = "Update Status: FAILED (Info may be existed)";
            //       statusObj.style.display = "";
            //    }

            // }
            
          })
          .catch((err) => {
             alert(`Error: ${err.messages}`);
          });
        } else {
          console.log(`not saving data due to in debug mode`);
          this.showDialog = false;
        }
      },

      //openTab(evt, tabname) {
      openTab(tabname)  {
         /*
         var i, tabcontent, tablinks;

         // Get all elements with class="tabcontent" and hide them
         tabcontent = document.getElementsByClassName("tabcontent");
         for (i = 0; i < tabcontent.length; i++) {
              tabcontent[i].style.display = "none";
         }

         // Get all elements with class="tablinks" and remove the class "active"
         tablinks = document.getElementsByClassName("tablinks");
         for (i = 0; i < tablinks.length; i++) {
             tablinks[i].className = tablinks[i].className.replace(" active", "");
         }

         // Show the current tab, and add an "active" class to the button that opened the tab
         document.getElementById(tabname).style.display = "block";
         evt.currentTarget.className += " active";   
        */
         console.log("tabname: " + tabname);
         
         if (tabname === "Main")
         {
            this.isFSIMain = true;
         }

      },

      getContentFromBrace(inputVal) {
      var openbraceIndx = -1;
         var closebraceIndx = -1;
         var retVal = "";
         if (inputVal && inputVal != "") {
            openbraceIndx = inputVal.indexOf("(");
            closebraceIndx = inputVal.indexOf(")");
            if (openbraceIndx >= 1) {
               if (closebraceIndx > openbraceIndx) {
                  retVal = inputVal.substr(openbraceIndx + 1, closebraceIndx - openbraceIndx - 1);
                  //console.log("retVal from brace: " + retVal);
               } else if (closebraceIndx < 0) {
                  retVal = inputVal.substr(openbraceIndx + 1, inputVal.length - openbraceIndx);
                  //console.log("retVal from brace1: " + retVal);
               }
            } else {
               retVal = inputVal;
            }
            return retVal;
         } else {
            return inputVal;
         }    
      },

      convertdateformat(date)
      {
         if (date && date != "" && date.length == 8)
         {
            const p_year = date.substring(0,4);
            const p_month = date.substring(4,6);
            const p_day = date.substring(6,8);
            const ret_date = `${p_month}/${p_day}/${p_year}`;
            console.log(`return date: ${ret_date}`);
            return ret_date;

            //var p_date = new Date(date);
            //console.log(`convert date: ${date} to ${p_date}`);
            //if (p_date)
            //{
            //   const p_year = p_date.getFullYear();
            //   const p_month = p_date.getMonth();
            //  const p_day = p_date.getDay();
            //   const ret_date = `${p_month}/${p_day}/${p_year}`;
            //   console.log(`return date: ${ret_date}`);
            //   return ret_date;
            //}
            //return date;
         } else {
           return date;
         }
      },

      saveData() {
         //this.doSaveUser();
         $("#submit").click();
      },
    },
  };
</script>